import { createApiCall } from 'lib/base';

const CALC_WEALTH_PROGRAM_FEES = 'WEALTH/CALC_WEALTH_PROGRAM_FEES';

const apiCall = createApiCall(
  CALC_WEALTH_PROGRAM_FEES,
  ({ id, date }: { id: string; date?: string }) => ({
    endpoint: `/api/admin/wealth/programs/${id}/fees/calc`,
    method: 'POST',
    body: JSON.stringify({ date }),
    notify: true,
  })
);

export default apiCall;
